import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { rem } from '@utils/rem';

import { Flex, Box } from '../grid';
import { Subheading } from '../typography';
import { overlayStyles, wrapperStyles } from '../content-image/styles';

const RestaurantComingSoonBanner = ({ address }) => {
  return (
    <Wrapper backgroundColor="red100">
      <Box backgroundColor="transparent" width="100%" px={rem(1.5)}>
        <Flex
          flexDirection={{ xs: 'column' }}
          alignItems="center"
          justifyContent="center"
          py={{ xs: '24px', md: '32px' }}
        >
          <Subheading variant={4} display="flex" alignItems="center" pb="0.66rem" textAlign="center">
            <Flex
              backgroundColor="error500"
              mr="0.5rem"
              position="relative"
              height={{ xs: '12px', md: '16px' }}
              width={{ xs: '12px', md: '16px' }}
              borderRadius="100%"
            />
            New Restaurant - Grilling Soon!
          </Subheading>
          <Subheading variant={5}>{address}</Subheading>
        </Flex>
      </Box>
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  ${wrapperStyles}
  ${overlayStyles}
`;

RestaurantComingSoonBanner.propTypes = {
  address: PropTypes.string.isRequired,
};
export { RestaurantComingSoonBanner };
